import { FormControl } from '../../../../../../components/FormUtilities'
import Helper from '../../../../../../components/Helper'
import RC from './RC'
import TableProducts from './TableProducts'
import { formLogisticalCost, tableRCsControl } from '../../storageStep2'

export default function Fields2() {
    const tableRCs = tableRCsControl.getDataList()
    const { props } = formLogisticalCost.useValue('rcs')
    const { props: productIds } = formLogisticalCost.useValue('productIds')

    return (
        <>
            <FormControl
                label="Aplicar a RC's"
                col="span-6"
                className="mb-4"
                required
            >
                {tableRCs.map(d => (
                    <RC
                        value={d.reception_id.toString()}
                        key={d.reception_id}
                        checked={
                            !!props.value.find(
                                option =>
                                    option.value === d.reception_id.toString()
                            )
                        }
                        label={d.rc}
                    />
                ))}
                <Helper>{props.helper}</Helper>
            </FormControl>
            <TableProducts
                rcIds={props.value.map(v => Number(v.value))}
                productIds={productIds.value}
                setProductIds={_productIds =>
                    formLogisticalCost.setValue('productIds', _productIds)
                }
            />
        </>
    )
}
